import thumbnail_image_1 from 'assets/images/project_thumbnail_images/thumbnail_image_1.png';
import thumbnail_image_2 from 'assets/images/project_thumbnail_images/thumbnail_image_2.png';
import thumbnail_image_3 from 'assets/images/project_thumbnail_images/thumbnail_image_3.png';
import thumbnail_image_4 from 'assets/images/project_thumbnail_images/thumbnail_image_4.png';
import thumbnail_image_5 from 'assets/images/project_thumbnail_images/thumbnail_image_5.png';
import thumbnail_image_6 from 'assets/images/project_thumbnail_images/thumbnail_image_6.png';
import thumbnail_image_7 from 'assets/images/project_thumbnail_images/thumbnail_image_7.png';
import thumbnail_image_8 from 'assets/images/project_thumbnail_images/thumbnail_image_8.png';
import thumbnail_image_9 from 'assets/images/project_thumbnail_images/thumbnail_image_9.png';
import thumbnail_image_10 from 'assets/images/project_thumbnail_images/thumbnail_image_10.png';

import { convertToBase64 } from './globalFunctions';

// Cache for storing fetched images as blob URLs
const imageCache = new Map();

// Utility function to fetch an image from URL and convert it to a blob URL
export const fetchImageAsBlob = async url => {
  try {
    // Check if image is already cached
    if (imageCache.has(url)) {
      return imageCache.get(url);
    }

    // Fetch the image
    const response = await fetch(url, {
      mode: 'cors',
      credentials: 'omit',
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch image: ${response.status}`);
    }

    // Convert to blob
    const blob = await response.blob();

    // Create blob URL for immediate use
    const blobUrl = typeof URL !== 'undefined' && URL.createObjectURL
      ? URL.createObjectURL(blob)
      : url; // Fallback for IE11

    // Cache the blob URL
    imageCache.set(url, blobUrl);

    return blobUrl;
  }
  catch (error) {
    // eslint-disable-next-line no-console
    console.warn(`Failed to fetch image from ${url}:`, error);

    // Return original URL as fallback
    return url;
  }
};

// Utility function to prefetch multiple images and return them as blob URLs
export const prefetchImagesAsBlobs = async imageUrls => {
  const promises = imageUrls.map(async url => {
    try {
      const blobUrl = await fetchImageAsBlob(url);

      return { originalUrl: url, blobUrl };
    }
    catch (error) {
      // eslint-disable-next-line no-console
      console.warn(`Failed to prefetch image ${url}:`, error);

      return { originalUrl: url, blobUrl: url }; // Fallback to original URL
    }
  });

  return Promise.all(promises);
};

// Utility to clear image cache (useful for memory management)
export const clearImageCache = () => {
  // Revoke all blob URLs to free memory
  imageCache.forEach(blobUrl => {
    if (typeof URL !== 'undefined' && URL.revokeObjectURL) {
      URL.revokeObjectURL(blobUrl);
    }
  });
  imageCache.clear();
};

const getRandomThumbnailImage = projectsCount => [
  thumbnail_image_1,
  thumbnail_image_2,
  thumbnail_image_3,
  thumbnail_image_4,
  thumbnail_image_5,
  thumbnail_image_6,
  thumbnail_image_7,
  thumbnail_image_8,
  thumbnail_image_9,
  thumbnail_image_10,
][projectsCount % 10 || 0];

export const getProjectThumbnail = async projectsCount => {
  const thumbnailImage = await (await fetch(getRandomThumbnailImage(projectsCount))).blob();
  const base64Image = await convertToBase64(thumbnailImage);

  return base64Image;
};
